<template>
    <!-- Desktop Navigation -->
    <nav class="d-none d-md-flex">
        <div class="nav-container">
            <a
                v-for="item in navigationItems"
                :key="item.id"
                @click.prevent="$emit('nav-link-click', item.id)"
                class="nav-link"
            >
                {{ item.label }}
            </a>
        </div>
    </nav>

    <!-- Mobile Navigation -->
    <nav class="d-md-none mobile-nav">
        <v-menu
            v-model="isExpanded"
            :close-on-content-click="false"
            location="top end"
            offset="10"
            scrim
        >
            <template v-slot:activator="{ props }">
                <button
                    v-bind="props"
                    class="mobile-nav-toggle"
                    :class="{ 'expanded': isExpanded }"
                >
                    <span class="toggle-icon"></span>
                </button>
            </template>

            <v-list class="mobile-nav-menu">
                <v-list-item
                    v-for="item in navigationItems"
                    :key="item.id"
                    @click="navigateTo(item.id)"
                    class="mobile-nav-link"
                >
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </nav>
</template>

<script>
export default {
    name: "NavigationMenu",

    emits: ["nav-link-click"],

    data() {
        return {
            isExpanded: false,
            navigationItems: [
                { id: 'invitation', label: 'Invitation' },
                { id: 'rsvp', label: 'RSVP' },
                { id: 'our-story', label: 'Our Story' },
                { id: 'accommodation', label: 'Accommodation' },
                { id: 'gifts', label: 'Gifts' },
                { id: 'faq', label: 'FAQ' }
            ]
        }
    },

    methods: {
        navigateTo(section) {
            this.$emit('nav-link-click', section);
            this.isExpanded = false;
        }
    }
}
</script>

<style scoped>
/* Desktop Navigation Styles */
.nav-container {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 2rem;
	margin: 0 auto;
}

.nav-link {
	color: #333;
	text-decoration: none;
	font-size: 1.1rem;
	font-weight: 500;
	padding: 0.5rem 1rem;
	border-radius: 6px;
	transition: all 0.3s ease;
	position: relative;
	cursor: pointer;
}

.nav-link::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 50%;
	width: 0;
	height: 2px;
	background-color: var(--primary-green);
	transition: all 0.3s ease;
	transform: translateX(-50%);
}

.nav-link:hover::after {
	width: 80%;
}

/* Mobile Navigation Styles */
.mobile-nav {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    z-index: 1000;
    /* Ensure the nav stays within viewport bounds */
    max-width: calc(100vw - 4rem);
    overflow: visible;
}


.mobile-nav-toggle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border: 2px solid #dee2e6;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1001;
}

.mobile-nav-toggle:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
}

.mobile-nav-toggle.expanded {
    background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
    transform: rotate(45deg);
}

.toggle-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23333'%3E%3Cpath d='M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'/%3E%3C/svg%3E") no-repeat center;
    background-size: contain;
    transition: all 0.3s ease;
}

.mobile-nav-toggle.expanded .toggle-icon {
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23333'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E") no-repeat center;
    background-size: contain;
}

.mobile-nav-menu {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px);
    border-radius: 12px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    min-width: 160px !important;
    padding: 0.5rem 0 !important;
}

.mobile-nav-link {
    min-height: 48px !important;
    padding: 0.75rem 1.5rem !important;
    color: #333 !important;
    font-family: "Playfair", serif !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    transition: all 0.2s ease !important;
    text-align: center !important;
}

.mobile-nav-link:hover {
    background-color: rgba(0, 0, 0, 0.05) !important;
    color: #1976d2 !important;
}

.mobile-nav-link:first-child {
    border-radius: 12px 12px 0 0 !important;
}

.mobile-nav-link:last-child {
    border-radius: 0 0 12px 12px !important;
}

.mobile-nav-link .v-list-item-title {
    color: inherit !important;
    font-family: inherit !important;
    font-size: inherit !important;
    font-weight: inherit !important;
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .mobile-nav {
        bottom: 1.5rem;
        right: 1.5rem;
    }

    .mobile-nav-toggle {
        width: 55px;
        height: 55px;
    }

    .mobile-nav-menu {
        min-width: 140px !important;
    }
}
</style>